import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    inject,
    Input,
} from '@angular/core';
import {
    EntityChangeTrackingDto,
    IChangeTrackingFacade,
    IEntity,
    ISearchFields,
} from '@pf/shared-common';

import { TableColumnBuilder } from '@pf/shared-ui';
import { ChangesCellRendererComponent } from './changes-cell-renderer.component';

@Component({
    selector: 'platform-detailed-history-view',
    templateUrl: './detailed-history-view.component.html',
    styleUrls: ['./detailed-history-view.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class DetailedHistoryViewComponent {
    private _cdr = inject(ChangeDetectorRef);
    @Input() changeTrackingFacade!: IChangeTrackingFacade<IEntity>;
    @Input() entityName!: string;

    searchField: ISearchFields<EntityChangeTrackingDto<IEntity>> = ['entity'];

    get columns() {
        return new TableColumnBuilder<EntityChangeTrackingDto<IEntity>>()
            .withColumn({
                field: 'changes',
                headerName: 'Changes',
                component: ChangesCellRendererComponent,
                componentProps: {
                    customValueTransformer:
                        this.changeTrackingFacade?.customValueFormatter,
                    excludedFields: this.changeTrackingFacade?.excludedFields,
                },
                width: 400,
            })
            .withColumn({
                field: 'userEmail',
                headerName: 'User',
            })
            .withColumn({
                field: 'createdDate',
                headerName: 'Time Changed',
                type: 'datetime',
            }).columns;
    }

    onDataChanged() {
        this._cdr.markForCheck();
    }
}
